import { useContext, useEffect, useState } from "react";
import { getLocal } from "../services/locales.service";
import { TenantsContext } from "../../../context/tenants.context";
import { LocalVendedorDTO } from "../../../dto/LocalDTO";

export const useLocal = (idLocal: number) => {
  const [local, setLocal] = useState<LocalVendedorDTO>();
  const [loading, setLoading] = useState<boolean>(true);
  const { tenant } = useContext(TenantsContext);

  const fetchData = async (idLocal: number) => {
    setLoading(true);
    await getLocal(idLocal, tenant)
      .then((res) => setLocal(res.data.data))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (!idLocal) return setLoading(false);
    fetchData(idLocal);
  }, [idLocal]);

  return { local, fetchData, loading };
};
